import { useDispatch, useSelector } from "react-redux";
import { resetData } from "../../features/login/LoginSlice";
import toast from "react-hot-toast";
import { useCallback, useEffect, useRef, useState } from "react";
import {
  resetConfiguration,
  setConfiguration,
} from "../../features/configuration/ConfigurationSlice";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { useNavigate } from "react-router-dom";

export const useNavbar = () => {
  const dispatch = useDispatch();
  const issuesDropdownRef = useRef(null);
  const logsDropdownRef = useRef(null);
  const dropdownsContainerRef = useRef(null);
  const navigate = useNavigate();
  const { authData, userData, isAdmin } = useSelector((state) => state.loginSlice);
  const { client: rootClient, environment: rootEnvironment } = useSelector(
    (state) => state.configurationSlice
  );

  const [environments, setEnvironments] = useState([]);
  const [clients, setClients] = useState([]);

  const toggleDropdown = useCallback((dropdownRef) => {
    if (dropdownRef.current) {
      const isOpen = dropdownRef.current.style.display === "block";
      dropdownRef.current.style.display = isOpen ? "none" : "block";
    }
  }, []);

  const closeDropdowns = useCallback(() => {
    if (issuesDropdownRef.current)
      issuesDropdownRef.current.style.display = "none";
    if (logsDropdownRef.current) logsDropdownRef.current.style.display = "none";
  }, []);

  const handleClickOutside = useCallback(
    (event) => {
      if (
        dropdownsContainerRef.current &&
        !dropdownsContainerRef.current.contains(event.target)
      ) {
        closeDropdowns();
      }
    },
    [closeDropdowns]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  const handleLogout = async () => {
    dispatch(resetData());
    dispatch(resetConfiguration());
    toast.success("Logged-out Successfully.");
  };

  const fetchEnvironments = async () => {
    try {
      // setLoader(true);
      let url = `${endpoint.GET_ENVIRONMENTS}`;

      const response = await apiHandler({
        url: url,
        method: "GET",
        navigate,
        dispatch,
        authToken: authData,
      });

      if (response.data.success) {
        setEnvironments(response.data.data);
        dispatch(
          setConfiguration({
            value: response.data.data.find(
              (environment) => environment.environment === "preprod"
            )._id,
            type: "environment",
          })
        );
      } else {
        setEnvironments([]);
        //console.error("Failed to fetchEnvironments:", response.data.message);
      }
    } catch (error) {
      //console.error("Error fetchEnvironments:", error);
      setEnvironments([]);
    } finally {
      // setLoader(false);
    }
  };

  const fetchClients = async () => {
    try {
      // setLoader(true);
      let url = `${endpoint.GET_CLIENTS}`;

      const response = await apiHandler({
        url: url,
        method: "GET",
        navigate,
        dispatch,
        authToken: authData,
      });

      if (response.data.success) {
        setClients(response.data.data);
        dispatch(
          setConfiguration({ value: response.data.data[0]._id, type: "client" })
        );
      } else {
        setClients([]);
        //console.error("Failed to fetchClients:", response.data.message);
      }
    } catch (error) {
      //console.error("Error fetchClients:", error);
      setClients([]);
    } finally {
      // setLoader(false);
    }
  };

  useEffect(() => {
    fetchEnvironments();
    // if (userData.client === "Futuresoft") {
      fetchClients();
    // } else {
    //   dispatch(setConfiguration({ value: userData.clientId, type: "client" }));
    // }
  }, []);

  const handleSelection = (value, type) => {
    dispatch(setConfiguration({ value, type }));
  };

  const getCurrentClientName = () => {
    const currentClient = clients.find((client) => client._id === rootClient);
    return currentClient ? currentClient.client_name : "";
  };

  return {
    handleLogout,
    toggleDropdown,
    closeDropdowns,
    issuesDropdownRef,
    logsDropdownRef,
    dropdownsContainerRef,
    environments,
    clients,
    handleSelection,
    userData,
    rootClient,
    rootEnvironment,
    getCurrentClientName,
    isAdmin
  };
};
